import React, { useEffect, useState } from 'react';
import { css } from 'styled-components';
import Icon from '@vfuk/core-icon';
import Heading from '@vfuk/core-heading';
import Spacing from '@vfuk/core-spacing';
import { Link } from 'gatsby';
import { ReactComponent as ChevronRight } from '../../images/icon/chevron-right.svg';
import { FeatureGridProps } from './types/FeatureGrid.types';
import runSeoEventData from '../../helpers/runSeoData';
import { isValidUrl } from '../../helpers/urlDetection';
import { FeatureGridWrapper, chevronNewLine } from './styles/FeatureGrid.styles';
import fireButtonAndLinkClicksEvent from '../../helpers/fireButtonAndLinkClicksEvent';

const FeatureGrid: React.FC<FeatureGridProps> = ({ feature, index }) => {
  const { iconRef, name, body, linkSlug, seoEventData } = feature;
  const linkSlugIsExternal = isValidUrl(linkSlug);

  const [pageTitle, setPageTitle] = useState<string>('');

  useEffect(() => {
    setTimeout(() => {
      // TODO: This two lines below is needed because the title of the html on the "/" path is not set. When this is fixed, then they can be removed
      let metaName = document
        .querySelector('meta[property="og:title"]')
        .getAttribute('content');
      metaName = metaName ? metaName : 'Not set';
      setPageTitle(document.title.length == 0 ? metaName : document.title);
    }, 500);
  }, []);

  const content = (
    <>
      <div
        css={css`
          color: var(--red);
        `}
      >
        <Spacing spacingLevel={{ bottom: 4 }}>
          <Icon name={iconRef} group="system" appearance="secondary" size={5} />
        </Spacing>
      </div>
      <Spacing spacingLevel={{ bottom: 2 }}>
        <Heading level={5} justify="center" weight={2}>
          {name}
          <span css={chevronNewLine}>
            &#65279;
            <ChevronRight />
          </span>
        </Heading>
      </Spacing>
      <p>{body.body}</p>
    </>
  );

  return (
    <FeatureGridWrapper>
      <div
        data-testid={`feature-${index}`}
        onClick={() => {
          runSeoEventData(seoEventData.seoEventData); // This helper function will be removed when the Tealium tracking is completed for all pages and actions in every OpCo.
          fireButtonAndLinkClicksEvent({ event_label: name, event_action: "link click" });
        }}
      >
        {linkSlugIsExternal && (
          <a
            title={name}
            data-analytics-element={name}
            data-analytics-category="Link"
            data-analytics-context={pageTitle}
            href={linkSlug}
          >
            {content}
          </a>
        )}
        {!linkSlugIsExternal && (
          <Link
            title={name}
            data-analytics-element={name}
            data-analytics-category="Link"
            data-analytics-context={pageTitle}
            to={`/${linkSlug}`}
          >
            {content}
          </Link>
        )}
      </div>
    </FeatureGridWrapper>
  );
};

export default FeatureGrid;
